import React from "react";
import Slider from "react-slick";
import useStyles, {
  CarouselContainer,
  CarouselIMG,
  FlexDate,
  SpanDot,
  Span,
} from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  Timeline,
  Inventory,
  Group,
  Report,
  CalendarMonth
} from "@mui/icons-material";
import {
  get_sales_order,
  dashboard,
  get_pending_order
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import useUser from "../../hooks/useUser";

export default function Dashboard() {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    get_user
  } = useUser

  const [loading, setLoading] = React.useState(false)
  const [saleList, setSaleList] = React.useState(null);
  const [pendingsaleList, setPendingSaleList] = React.useState(null);
  // console.log(saleList)
  const [dashboardData, setDashboardData] = React.useState(null);

  const getData = () => {
    setLoading(true);

    // Load dashboard data first (most important)
    dashboard({
      token: localStorage.getItem("token"),
    }).then((resDash) => {
      setDashboardData(resDash.data)
      setLoading(false); // Dashboard data loaded, can show loading as false
    }).catch((error) => {
      console.error('Dashboard data error:', error);
      setLoading(false);
    });

    // Load sales order data
    get_sales_order({
      page: 1,
      salesrep: 0,
      // sort: sort
    }).then((salesResponse) => {
      if (salesResponse.data && salesResponse.data.length != 0) {
        const salesData = salesResponse.data.slice(0, 5);
        setSaleList(salesData);
      }
    }).catch((error) => {
      console.error('Sales data error:', error);
    });

    // Load pending order data
    get_pending_order({
      page: 1,
      // sort: sort
    }).then((pendingResponse) => {
      if (pendingResponse.status === true && pendingResponse.data && pendingResponse.data.length != 0) {
        const pendingData = pendingResponse.data.slice(0, 5);
        setPendingSaleList(pendingData);
      } else {
        setPendingSaleList([]);
      }
    }).catch((error) => {
      console.error('Pending order error:', error);
      setPendingSaleList([]);
    });
  };

  React.useEffect(() => {
    getData();
  }, []);
  return (
    <React.Fragment>
      <Navbar2
        children={
          <Section pd="2rem">
            <div>
              <Paragraph color="#1a5386" bold="600" size="24px" textTransform="capitalize">
                Hi, welcome back
              </Paragraph>
              <br />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={5}>
                  <div className={classes.theDCard}>
                    <div className={classes.theDCIcon}>
                      <Timeline style={{ color: "#fff", fontSize: "2rem" }} />
                    </div>
                    <Paragraph color="#000" bold="600" size="24px" margin="1rem 0">
                      {loading ? "..." : (dashboardData != null ? Number(dashboardData.today_sales || 0).toLocaleString() : "0")}
                    </Paragraph>
                    <Paragraph color="#000" size="12px">
                      Today Sales
                    </Paragraph>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={5}>
                  <div className={classes.theDCard}>
                    <div className={classes.theDCIcon}>
                      <Inventory style={{ color: "#fff", fontSize: "2rem" }} />
                    </div>
                    <Paragraph color="#000" bold="600" size="24px" margin="1rem 0">
                      {loading ? "..." : (dashboardData != null ? Number(dashboardData.today_order || 0).toLocaleString() : "0")}
                    </Paragraph>
                    <Paragraph color="#000" size="12px">
                      Today Orders
                    </Paragraph>
                  </div>
                </Grid>
              </Grid>
              <br />
              <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={4}>
                  <div className={classes.theDCard}>
                    <div className={classes.theDCIcon}>
                      <CalendarMonth style={{ color: "#fff", fontSize: "2rem" }} />
                    </div>
                    <Paragraph color="#000" bold="600" size="24px" margin="1rem 0">
                      {loading ? "..." : (dashboardData != null ? Number(dashboardData.daily_sales || 0).toLocaleString() : "0")}
                    </Paragraph>
                    <Paragraph color="#000" size="12px">
                      Daily Summary Orders
                    </Paragraph>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <div className={classes.theDCard}>
                    <div className={classes.theDCIcon}>
                      <CalendarMonth style={{ color: "#fff", fontSize: "2rem" }} />
                    </div>
                    <Paragraph color="#000" bold="600" size="24px" margin="1rem 0">
                      {loading ? "..." : (dashboardData != null ? Number(dashboardData.weekly_sales || 0).toLocaleString() : "0")}
                    </Paragraph>
                    <Paragraph color="#000" size="12px">
                      Weekly Summary Orders
                    </Paragraph>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <div className={classes.theDCard}>
                    <div className={classes.theDCIcon}>
                      <CalendarMonth style={{ color: "#fff", fontSize: "2rem" }} />
                    </div>
                    <Paragraph color="#000" bold="600" size="24px" margin="1rem 0">
                      {loading ? "..." : (dashboardData != null ? Number(dashboardData.monthly_sales || 0).toLocaleString() : "0")}
                    </Paragraph>
                    <Paragraph color="#000" size="12px">
                      Monthly Summary Orders
                    </Paragraph>
                  </div>
                </Grid>
              </Grid>
              <br/>
              {/* <Card className={classes.theCard}>
                <Paragraph color="#707070" size="16px" bold="600" margin="0 0 0.5rem">
                  Total Supplier
                </Paragraph>
                <TableContainer>
                  <Table>
                    <TableHead style={{ backgroundColor: "#707070" }}>
                      <TableRow>
                        <TableCell style={{ borderRadius: "10px 0 0 10px" }} className={classes.theHeadTitle}>
                          Order Number
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Customer
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Order Date
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Delivery Date
                        </TableCell>
                        <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <a style={{ display: "contents" }}>
                          <TableCell style={{ textDecoration: "underline" }}>CN000000000</TableCell>
                          <TableCell>Customer Name</TableCell>
                          <TableCell>2021-12-12 11.11.11</TableCell>
                          <TableCell>2021-12-12 11.11.11</TableCell>
                          <TableCell>RM1000.00</TableCell>
                        </a>
                      </TableRow>
                      <TableRow>
                        <a style={{ display: "contents" }}>
                          <TableCell style={{ textDecoration: "underline" }}>CN000000000</TableCell>
                          <TableCell>Customer Name</TableCell>
                          <TableCell>2021-12-12 11.11.11</TableCell>
                          <TableCell>2021-12-12 11.11.11</TableCell>
                          <TableCell>RM1000.00</TableCell>
                        </a>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <div style={{
                  borderTop: "1px solid #707070",
                  margin: "1rem 0 0",
                  cursor: "pointer"
                }}>
                  <Paragraph color="#707070" size="12px" bold="600" margin="0.5rem 0 0" center>
                    view all	&#62;
                  </Paragraph>
                </div>
              </Card> */}
              <br />
              <Card className={classes.theCard}>
                <Paragraph color="#1a5386" size="16px" bold="600" margin="0 0 0.5rem">
                  New Sales Order
                </Paragraph>
                <br />
                <TableContainer>
                  <Table>
                    <TableHead style={{ backgroundColor: "#1a5386" }}>
                      <TableRow>
                        <TableCell style={{
                          borderRadius: "10px 0 0 10px"
                        }} className={classes.theHeadTitle}>
                          Order Number
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Entity Id
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Status
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Payment
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Amount
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Sale Rep
                        </TableCell>
                        <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                          Created Date
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {saleList !== null && saleList.length > 0 &&
                      <TableBody>
                        {saleList.map((item, index) =>
                          <TableRow key={item.sales_order_id || index}>
                            <TableCell className={classes.theUnderLineLabel}
                              style={{
                                verticalAlign: 'top',
                                width: "5%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.sales_order_id != "" && item.sales_order_id != null ? item.sales_order_id : "-"}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "20%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.entityid != "" && item.entityid != null ? item.entityid : "-"}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "10%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.status}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "15%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              <div>
                                Currency: {item.currency}
                              </div>
                              <div>
                                Type: {item.paymenttype}
                              </div>
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "20%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              <div
                                style={{ color: "#1A5386" }}
                              >Final Amount: {item.final_amount}</div>
                              {item.deposit_amount != '0.00' &&
                                <React.Fragment>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#C52626",
                                    }}
                                  >Deposit Amount: {item.deposit_amount}</div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#C52626",
                                    }}
                                  >Outstanding Amount: {item.outstanding_amount}</div>
                                </React.Fragment>
                              }

                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "20%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.salesrep_name}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "10%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.created_date}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    }
                  </Table>
                </TableContainer>
                <div style={{
                  borderTop: "1px solid #707070",
                  margin: "1rem 0 0",
                  cursor: "pointer"
                }}
                  onClick={() => navigate('/sale')}
                >
                  <Paragraph color="#1a5386" size="12px" bold="600" margin="0.5rem 0 0" center>
                    view all	&#62;
                  </Paragraph>
                </div>
              </Card>
              <br />
              <Card className={classes.theCard}>
                <Paragraph color="#1a5386" size="16px" bold="600" margin="0 0 0.5rem">
                  Pending Sales Order
                </Paragraph>
                <br />
                <TableContainer>
                  <Table>
                    <TableHead style={{ backgroundColor: "#1a5386" }}>
                      <TableRow>
                        <TableCell style={{
                          borderRadius: "10px 0 0 10px"
                        }} className={classes.theHeadTitle}>
                          Order Number
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Entity Id
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Status
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Payment
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Amount
                        </TableCell>
                        <TableCell className={classes.theHeadTitle}>
                          Sale Rep
                        </TableCell>
                        <TableCell style={{ borderRadius: "0 10px 10px 0" }} className={classes.theHeadTitle}>
                          Created Date
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {pendingsaleList !== null && pendingsaleList.length > 0 &&
                      <TableBody>
                        {pendingsaleList.map((item, index) =>
                          <TableRow key={item.sales_order_id || index}>
                            <TableCell className={classes.theUnderLineLabel}
                              style={{
                                verticalAlign: 'top',
                                width: "5%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.sales_order_id != "" && item.sales_order_id != null ? item.sales_order_id : "-"}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "20%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.entityid != "" && item.entityid != null ? item.entityid : "-"}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "10%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.status}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "15%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              <div>
                                Currency: {item.currency}
                              </div>
                              <div>
                                Type: {item.paymenttype}
                              </div>
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "20%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              <div
                                style={{ color: "#1A5386" }}
                              >Final Amount: {item.final_amount}</div>
                              {item.deposit_amount != '0.00' &&
                                <React.Fragment>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#C52626",
                                    }}
                                  >Deposit Amount: {item.deposit_amount}</div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      color: "#C52626",
                                    }}
                                  >Outstanding Amount: {item.outstanding_amount}</div>
                                </React.Fragment>
                              }

                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "20%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.salesrep_name}
                            </TableCell>
                            <TableCell
                              style={{
                                verticalAlign: 'top',
                                width: "10%"
                              }}
                              onClick={() => navigate("/saledetail/" + item.sales_order_id)}
                            >
                              {item.created_date}
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    }
                    {pendingsaleList !== null && pendingsaleList.length === 0 &&
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan="7" style={{ textAlign: 'center', padding: '2rem' }}>
                            No pending orders found
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    }
                  </Table>
                </TableContainer>
                <div style={{
                  borderTop: "1px solid #707070",
                  margin: "1rem 0 0",
                  cursor: "pointer"
                }}
                  onClick={() => navigate('/sale')}
                >
                  <Paragraph color="#1a5386" size="12px" bold="600" margin="0.5rem 0 0" center>
                    view all	&#62;
                  </Paragraph>
                </div>
              </Card>
            </div>
          </Section>
        }
      />
    </React.Fragment>
  );
}
